import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';

export const moveMenuItemToSection = async (
  menuId: string,
  itemId: string,
  moveToSectionId: string,
  newDisplayOrder: number,
): Promise<any> => {
  try {
    const response = await fetch(`${API_URL}/menus/${menuId}/items/${itemId}`, {
      method: 'PUT',
      body: JSON.stringify({ section_id: moveToSectionId, display_order: newDisplayOrder }),
      headers: {
        'content-type': 'application/json',
      },
    });

    if (!response.ok) throw new Error();
  } catch {
    throw new Error('We have been unable to complete your request');
  }
};
